// extracted by mini-css-extract-plugin
export default {"innerWrapper":"qt-z","tooltipWrapper":"rt-z","icon":"st-z","tooltip":"tt-z","content":"ut-z"};